import {fetchDataPending, fetchDataSuccess, fetchDataError} from './../helpAction';
import fetchApi from "./fetchApi";

function fetchHelpAction() {
  return fetchApi('/v1/fc_api/help_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchHelpAction;
